// Elba Island itinerary — extracted from PDF

// Foto reali dei luoghi (Wikimedia Commons CC BY-SA + Unsplash/Pexels, verificate).
// Dove il posto esatto non ha foto libere reperibili (Canata, Straccoligno, Ferrato)
// si usa una foto reale della costa dell'Elba (Scaglieri) come riferimento più vicino.
const PHOTOS = {
  leGhiaie: "https://upload.wikimedia.org/wikipedia/commons/6/62/Isola_d%27Elba_-_Spiaggia_delle_Ghiaie.jpg",
  sansone: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Spiaggia_di_Sansone%2C_Elba_-_panoramio.jpg",
  capoBianco: "https://upload.wikimedia.org/wikipedia/commons/c/c8/Elba%2C_spiaggia_di_Capo_Bianco.jpg",
  fetovaia: "https://upload.wikimedia.org/wikipedia/commons/0/05/Fetovaia01.jpg",
  cavoli: "https://upload.wikimedia.org/wikipedia/commons/2/2a/Elba-Cavoli.jpg",
  seccheto: "https://upload.wikimedia.org/wikipedia/commons/1/1d/Spiaggia_di_Seccheto.jpg",
  lacona: "https://upload.wikimedia.org/wikipedia/commons/8/83/Tra_Norsi_e_Lacona_-_panoramio.jpg",
  santAndrea: "https://upload.wikimedia.org/wikipedia/commons/3/37/Sant_Andrea_1_-_Strand.jpg",
  cotoncello: "https://upload.wikimedia.org/wikipedia/commons/5/58/Sant_Andrea_Cotoncello_1_-_Felsstrand.jpg",
  portoferraioFaro: "https://images.pexels.com/photos/35471679/pexels-photo-35471679.jpeg?auto=compress&cs=tinysrgb&w=1600",
  portoferraioMarina: "https://images.pexels.com/photos/12341601/pexels-photo-12341601.jpeg?auto=compress&cs=tinysrgb&w=1600",
  capoliveriBar: "https://images.unsplash.com/photo-1648538332030-847f3951da72?fm=jpg&q=80&w=1600",
  capoliveriVicolo: "https://images.unsplash.com/photo-1648538331988-440528601341?fm=jpg&q=80&w=1600",
  marcianaMarinaBarca: "https://images.unsplash.com/photo-1655280313846-b99c6f40d7db?fm=jpg&q=80&w=1600",
  marcianaMarinaTorre: "https://images.unsplash.com/photo-1655280333278-bdb0688a006e?fm=jpg&q=80&w=1600",
  portoAzzurroPiazza: "https://images.unsplash.com/photo-1694710178038-29918cfad22f?fm=jpg&q=80&w=1600",
  portoAzzurroSpiaggia: "https://images.unsplash.com/photo-1655280868818-a5492b156bbd?fm=jpg&q=80&w=1600",
  costaScaglieri1: "https://images.pexels.com/photos/28542692/pexels-photo-28542692.jpeg?auto=compress&cs=tinysrgb&w=1600",
  costaScaglieri2: "https://images.pexels.com/photos/28542693/pexels-photo-28542693.jpeg?auto=compress&cs=tinysrgb&w=1600",
  food: "https://images.pexels.com/photos/33921434/pexels-photo-33921434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
};

export const TRIP = {
  title: "Isola d'Elba",
  subtitle: "Sette giorni tra granito, mare turchese e tramonti mediterranei",
  startDate: "2026-08-22",
  endDate: "2026-08-29",
  hotel: {
    name: "Hotel Residence Villa San Giovanni",
    url: "https://www.booking.com/hotel/it/e-residence-villa-san-giovanni.it.html",
    location: "Portoferraio",
  },
  goldenRule: {
    title: "La prima regola d'oro all'Elba",
    lines: [
      "Vento da nord (tramontana / maestrale) → vai a SUD",
      "Vento da sud (scirocco) → vai a NORD",
    ],
  },
  heroImage:
    "https://images.pexels.com/photos/30240235/pexels-photo-30240235.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
};

export const DAYS = [
  {
    id: 1,
    date: "2026-08-22",
    day: "Sabato",
    zone: "Portoferraio",
    title: "Arrivo e primo bagno",
    coords: { lat: 42.821, lng: 10.311, label: "Portoferraio · Le Ghiaie" },
    cover:
      "https://images.unsplash.com/photo-1632171639829-95267292f6a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxwb3J0b2ZlcnJhaW8lMjBpdGFseXxlbnwwfHx8fDE3ODcxNDE3ODB8MA&ixlib=rb-4.1.0&q=85&w=1600",
    story:
      "Il primo giorno è quello dell'arrivo. Traghetto, sistemazione in hotel e un primo assaggio del mare elbano prima del tramonto a Portoferraio.",
    timeline: [
      { time: "15:45", text: "Traghetto Piombino → Portoferraio" },
      { time: "16:30", text: "Check-in e sistemazione in hotel" },
      { time: "18:00", text: "Primo bagno a Le Ghiaie (10 min in auto)" },
      { time: "20:00", text: "Aperitivo + passeggiata nel centro storico" },
      { time: "21:30", text: "Cena a Portoferraio" },
    ],
    beaches: [
      {
        name: "Le Ghiaie",
        note: "Spiaggia bianca a 3 km / 10 min in auto. Bar, ristoranti, gelaterie e parcheggio a pagamento lungo il viale; stabilimento, noleggio pedalò e imbarcazioni sulla spiaggia.",
        wind: ["Scirocco"],
      },
    ],
    restaurants: [
      { name: "La Tonnina", where: "Calata Mazzini", tip: "Aperitivo elegante" },
      { name: "Sail Port", where: "Portoferraio", tip: "Aperitivo informale" },
    ],
    poi: ["Centro storico di Portoferraio"],
    tips: ["Arrivare presto per non avere difficoltà con i parcheggi auto."],
    gallery: [
      { url: PHOTOS.leGhiaie, caption: "Le Ghiaie" },
      { url: PHOTOS.portoferraioFaro, caption: "Portoferraio" },
      { url: PHOTOS.portoferraioMarina, caption: "Marina di Portoferraio" },
      { url: PHOTOS.food, caption: "Cena in centro" },
    ],
  },
  {
    id: 2,
    date: "2026-08-23",
    day: "Domenica",
    zone: "Nord",
    title: "Spiagge bianche del versante nord",
    coords: { lat: 42.8207, lng: 10.2892, label: "Sansone" },
    cover:
      "https://images.pexels.com/photos/30240235/pexels-photo-30240235.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
    story:
      "La giornata delle spiagge bianche con venti da sud. Sansone al mattino, poi Capo Bianco protetta dalle alte falesie, chiusura con aperitivo in centro.",
    timeline: [
      { time: "08:30", text: "Partenza (meglio anche prima)" },
      { time: "09:00", text: "Sansone (12 min in auto) — mattinata in spiaggia" },
      { time: "12:30", text: "Eventuale spostamento a Sorgente / Acquaviva" },
      { time: "13:30", text: "Pranzo" },
      { time: "15:30", text: "Capo Bianco — falesie e acqua limpida" },
      { time: "19:30", text: "Aperitivo + passeggiata a Portoferraio" },
    ],
    beaches: [
      {
        name: "Sansone",
        note: "Sassolini bianchi. Provinciale Portoferraio–Enfola, poi 4,5 km e a piedi. Stabilimento piccolo, noleggio pedalò. Parcheggio 18€ full day / 10€ mezza (dalle 14:00) / moto 5€.",
        wind: ["Scirocco", "Libeccio", "Mezzogiorno"],
      },
      {
        name: "Sorgente / Acquaviva",
        note: "Piccole, senza ombrelloni. Sentiero disconnesso: no ciabattine!",
      },
      {
        name: "Capo Bianco",
        note: "Falesie che proteggono, acqua limpida e calma. Capo Bianco Experience per aperitivo panoramico al tramonto, spesso dj set. Bazar sulla scalinata, stabilimento con pedalò e canoe.",
        wind: ["Scirocco"],
      },
    ],
    restaurants: [
      { name: "Panino / focaccia / frutta", where: "Portati da noi", tip: "Pranzo semplice in spiaggia" },
      { name: "Da Gianni", where: "Portoferraio", tip: "Cena di pesce" },
      { name: "Osteria Pepenero", where: "Portoferraio", tip: "Più elegante" },
    ],
    poi: [],
    tips: [
      "Giornata perfetta come 'jolly vento': se ci sono venti da sud/scirocco il nord è la scelta migliore.",
    ],
    gallery: [
      { url: PHOTOS.sansone, caption: "Sansone" },
      { url: PHOTOS.capoBianco, caption: "Capo Bianco" },
      { url: PHOTOS.portoferraioMarina, caption: "Aperitivo a Portoferraio" },
    ],
  },
  {
    id: 3,
    date: "2026-08-24",
    day: "Lunedì",
    zone: "Costa del Sole",
    title: "Fetovaia, Cavoli, Seccheto",
    coords: { lat: 42.7292, lng: 10.1547, label: "Fetovaia" },
    cover:
      "https://images.unsplash.com/photo-1515086215594-3427c60130a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxtZWRpdGVycmFuZWFuJTIwc3Vuc2V0fGVufDB8fHx8MTc4NzE0MTc4N3ww&ixlib=rb-4.1.0&q=85&w=1600",
    story:
      "Una delle giornate più belle. Fetovaia al mattino presto, Cavoli con la sua Grotta Azzurra, e se avanza tempo Seccheto per l'ultimo tuffo.",
    timeline: [
      { time: "08:00", text: "Partenza dall'hotel" },
      { time: "09:00", text: "Fetovaia — restarci parecchio" },
      { time: "13:00", text: "Pranzo in zona" },
      { time: "14:30", text: "Cavoli (10 min da Fetovaia)" },
      { time: "17:00", text: "Seccheto (facoltativo)" },
      { time: "19:30", text: "Rientro, doccia, aperitivo a Marina di Campo" },
    ],
    beaches: [
      {
        name: "Fetovaia",
        note: "Una delle più richieste — ~40 min d'auto dall'hotel, arrivare presto. Parcheggio 20€ full / 12€ mezza in alta stagione.",
        wind: ["Tramontana", "Mezzogiorno", "Libeccio", "Ponente", "Maestrale"],
      },
      {
        name: "Cavoli",
        note: "Sabbia, vivace, atmosfera giovane. Lato est stabilimenti, lato ovest libero e più tranquillo. Parcheggio a pagamento di fronte + custodito a metà via Cavoli.",
        wind: ["Tramontana", "Grecale", "Levante", "Ponente", "Maestrale"],
      },
      {
        name: "Seccheto",
        note: "Piccola e tranquilla, vicina a Cavoli.",
      },
    ],
    restaurants: [
      { name: "Pranzo in zona", where: "Fetovaia / Cavoli", tip: "Locali di spiaggia" },
      { name: "Cena", where: "Marina di Campo o rientro a Portoferraio", tip: "Aperitivo lungomare" },
    ],
    poi: ["Grotta Azzurra (Grotta di Mare) — raggiungibile in barca o pedalò dal lato est di Cavoli"],
    tips: ["Arrivare presto a Fetovaia per il parcheggio."],
    gallery: [
      { url: PHOTOS.fetovaia, caption: "Fetovaia" },
      { url: PHOTOS.cavoli, caption: "Cavoli" },
      { url: PHOTOS.seccheto, caption: "Seccheto" },
    ],
  },
  {
    id: 4,
    date: "2026-08-25",
    day: "Martedì",
    zone: "Lacona / Capoliveri",
    title: "Lacona + Canata (con camminata)",
    coords: { lat: 42.7461, lng: 10.2536, label: "Lacona" },
    cover:
      "https://images.unsplash.com/photo-1602983755773-77d3d5085cc4?auto=format&fit=crop&w=1600&q=80",
    story:
      "Mattina rilassata sulla spiaggia enorme di Lacona, poi la parte 'avventurosa' con la camminata di 15 minuti fino alla caletta selvaggia di Canata. Sera a Capoliveri.",
    timeline: [
      { time: "08:30", text: "Partenza (12 min in auto)" },
      { time: "09:00", text: "Lacona — spiaggia di 1,2 km, sabbia fine" },
      { time: "12:30", text: "Pranzo / panino in spiaggia" },
      { time: "14:00", text: "Trasferimento a piedi verso Canata (15 min)" },
      { time: "17:30", text: "Capoliveri — passeggiata nel centro storico" },
      { time: "20:00", text: "Aperitivo e cena a Capoliveri" },
    ],
    beaches: [
      {
        name: "Lacona",
        note: "1,2 km, sabbia fine, molteplici stabilimenti, sport acquatici, diving, noleggio imbarcazioni, canoe, lettini e ombrelloni.",
        wind: ["Tramontana", "Grecale", "Maestrale"],
      },
      {
        name: "Canata",
        note: "Caletta selvaggia, no servizi. 15 min a piedi dal parcheggio di Lacona (Via il Moletto) attraverso il Camping Stella Mare. Servono scarpette.",
        wind: ["Tramontana", "Grecale", "Levante", "Maestrale"],
      },
    ],
    restaurants: [
      { name: "Panino in spiaggia", where: "Lacona", tip: "Portatevi tutto il necessario" },
      { name: "Enoteca Fandango", where: "Capoliveri", tip: "Aperitivo" },
      { name: "Enoteca Monica Massei", where: "Capoliveri", tip: "Aperitivo, alternativa" },
      { name: "Cena", where: "Capoliveri centro storico", tip: "Serata nel borgo" },
    ],
    poi: ["Centro storico di Capoliveri"],
    tips: [
      "Per Canata portare acqua, ombrellone, scarpette e tutto il necessario.",
    ],
    gallery: [
      { url: PHOTOS.lacona, caption: "Lacona" },
      { url: PHOTOS.costaScaglieri1, caption: "Canata" },
      { url: PHOTOS.capoliveriBar, caption: "Capoliveri" },
      { url: PHOTOS.capoliveriVicolo, caption: "Centro storico di Capoliveri" },
    ],
  },
  {
    id: 5,
    date: "2026-08-26",
    day: "Mercoledì",
    zone: "Ovest",
    title: "Sant'Andrea + Cotoncello",
    coords: { lat: 42.8087, lng: 10.1391, label: "Sant'Andrea" },
    cover:
      "https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=1600&q=80",
    story:
      "La giornata paesaggisticamente più spettacolare: sabbia chiara, mare turchese, grandi rocce di granito. Sentiero sulle rocce fino alla piccola piscina naturale del Cotoncello.",
    timeline: [
      { time: "08:00", text: "Partenza — strada tortuosa, un'ora dall'hotel" },
      { time: "09:00", text: "Sant'Andrea + camminata sulle rocce" },
      { time: "11:30", text: "Cotoncello — piccola piscina naturale di sabbia" },
      { time: "13:00", text: "Pranzo a Sant'Andrea" },
      { time: "15:00", text: "Rientro verso Marciana Marina" },
      { time: "17:00", text: "La Fenicia / Fenicetta (facoltativo) o passeggiata" },
    ],
    beaches: [
      {
        name: "Sant'Andrea",
        note: "Sabbia chiara, mare turchese, rocce granitiche. Bar e ristoranti in spiaggia. Parcheggio a ~100m, una ventina di posti liberi, resto a parchimetro 1,50€/h (giu-set, 8-21).",
        wind: ["Scirocco", "Mezzogiorno", "Libeccio"],
      },
      {
        name: "Cotoncello",
        note: "Piscina naturale di sabbia circondata dal granito. Raggiungibile a piedi sulle rocce da Sant'Andrea.",
      },
      {
        name: "La Fenicia / Fenicetta",
        note: "Ultimo bagno vicino a Marciana Marina. Parcheggio sul lungomare a pagamento orario, o gratuito a 200m alle spalle del paese.",
        wind: ["Scirocco", "Mezzogiorno", "Libeccio"],
      },
    ],
    restaurants: [
      { name: "Pranzo a Sant'Andrea", where: "Bar/ristoranti sulla spiaggia", tip: "Vista mare" },
      { name: "Cena tranquilla", where: "Vicino all'hotel", tip: "Serata rilassata" },
    ],
    poi: ["Marciana Marina", "Costa granitica dell'Ovest"],
    tips: ["Non eliminare questa giornata: la combo Sant'Andrea + Cotoncello è unica."],
    gallery: [
      { url: PHOTOS.santAndrea, caption: "Sant'Andrea" },
      { url: PHOTOS.cotoncello, caption: "Cotoncello" },
      { url: PHOTOS.marcianaMarinaBarca, caption: "Marciana Marina" },
    ],
  },
  {
    id: 6,
    date: "2026-08-27",
    day: "Giovedì",
    zone: "Est",
    title: "Capoliveri orientale + Porto Azzurro",
    coords: { lat: 42.7654, lng: 10.3949, label: "Porto Azzurro" },
    cover:
      "https://images.unsplash.com/photo-1533050487297-09b450131914?auto=format&fit=crop&w=1600&q=80",
    story:
      "Cambio completo di paesaggio: Straccoligno organizzata e i più selvaggi Ferrato 1 e 2, perfetti per lo snorkeling. Chiusura sul lungomare di Porto Azzurro.",
    timeline: [
      { time: "08:30", text: "Partenza (30 min in macchina)" },
      { time: "09:15", text: "Straccoligno — mattinata" },
      { time: "12:30", text: "Pranzo (bar Area Sosta Ferrato o zona)" },
      { time: "14:00", text: "Ferrato 1/2 — snorkeling, natura" },
      { time: "16:00", text: "Porto Azzurro — passeggiata lungomare" },
      { time: "19:30", text: "Aperitivo e cena a Porto Azzurro" },
    ],
    beaches: [
      {
        name: "Straccoligno",
        note: "Comoda da raggiungere, servizi completi, bar e ristoranti, noleggio lettini, ombrelloni, pedalò e piccole imbarcazioni a motore.",
        wind: ["Mezzogiorno", "Libeccio", "Ponente", "Maestrale"],
      },
      {
        name: "Ferrato Uno",
        note: "Due sentieri: uno più comodo davanti a 'Villa Federico', l'altro a 900m da Straccoligno con parcheggio e semaforo (rosso = pieno). Ottima la combo Straccoligno → Ferrato Due, senza andare avanti e indietro.",
        wind: ["Scirocco", "Mezzogiorno", "Libeccio", "Ponente"],
      },
      {
        name: "Ferrato Due",
        note: "Sul lato destro di Ferrato Uno, scaletta in cemento. Perfetta per snorkeling. Proseguendo 200m si arriva a Malpasso di Capoliveri.",
        wind: ["Scirocco", "Mezzogiorno", "Libeccio", "Ponente"],
      },
    ],
    restaurants: [
      { name: "Osteria Locanda Cecconi", where: "Porto Azzurro", tip: "Pesce" },
      { name: "Osteria Da Farnese", where: "Porto Azzurro", tip: "Pesce" },
      { name: "Bar Area Sosta Ferrato", where: "Ferrato", tip: "Snack, gelato, pranzo veloce" },
    ],
    poi: ["Lungomare di Porto Azzurro", "Malpasso di Capoliveri (proseguendo dal sentiero)"],
    tips: ["Aperitivo assolutamente a Porto Azzurro."],
    gallery: [
      { url: PHOTOS.costaScaglieri2, caption: "Straccoligno" },
      { url: PHOTOS.costaScaglieri1, caption: "Ferrato" },
      { url: PHOTOS.portoAzzurroPiazza, caption: "Porto Azzurro" },
      { url: PHOTOS.portoAzzurroSpiaggia, caption: "Costa di Porto Azzurro" },
    ],
  },
  {
    id: 7,
    date: "2026-08-28",
    day: "Venerdì",
    zone: "Jolly",
    title: "Il giorno da decidere sul momento",
    coords: { lat: 42.78, lng: 10.19, label: "Elba (jolly)" },
    cover:
      "https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=1600&q=80",
    story:
      "Non fissato al 100% di proposito. Dopo sei giorni saprete quale spiaggia vi è piaciuta di più, dove è meglio con il vento del giorno e cosa vi siete persi.",
    timeline: [
      { time: "Mattino", text: "Sceglietelo in base a vento e voglia" },
      { time: "Pomeriggio", text: "Bis della spiaggia preferita o gita nuova" },
      { time: "Sera", text: "Cena dove vi va" },
    ],
    beaches: [
      { name: "Sansone + Capo Bianco (bis)", note: "Se il mare è calmo e bello." },
      { name: "Fetovaia (bis)", note: "Se volete tornare sulla preferita." },
      { name: "Canata / Lacona", note: "Se soffia Grecale/Levante — versante sud." },
      { name: "Piano B: Pomonte + Relitto dell'Elviscot", note: "Con Marciana Marina la sera." },
    ],
    restaurants: [{ name: "Da decidere", where: "Dove vi va", tip: "Libera scelta" }],
    poi: [
      "Se siete stanchi: Biodola + piscina hotel + aperitivo + cena",
      "Piano A: Calanova → Ferrato 2 → Porto Azzurro",
    ],
    tips: [
      "Scirocco → nord (Capo Bianco).",
      "Grecale/Levante → sud (Canata, Lacona).",
    ],
    gallery: [
      { url: PHOTOS.sansone, caption: "Sansone (bis)" },
      { url: PHOTOS.capoBianco, caption: "Capo Bianco (bis)" },
      { url: PHOTOS.fetovaia, caption: "Fetovaia (bis)" },
    ],
  },
  {
    id: 8,
    date: "2026-08-29",
    day: "Sabato",
    zone: "Portoferraio",
    title: "Ultimo bagno e traghetto",
    coords: { lat: 42.8078, lng: 10.3287, label: "Portoferraio · Porto" },
    cover:
      "https://images.unsplash.com/photo-1533692328991-08159ff19fca?auto=format&fit=crop&w=1600&q=80",
    story:
      "Niente gite lontane oggi. Colazione tranquilla, un ultimo bagno vicino all'hotel e poi il traghetto delle 13:15.",
    timeline: [
      { time: "09:00", text: "Colazione tranquilla" },
      { time: "10:00", text: "Le Ghiaie o spiaggia vicina all'hotel — ultimo bagno" },
      { time: "12:15", text: "Check-out e trasferimento al porto" },
      { time: "13:15", text: "Traghetto Portoferraio → Piombino" },
    ],
    beaches: [
      { name: "Le Ghiaie", note: "Ultimo tuffo comodo e vicino." },
    ],
    restaurants: [],
    poi: [],
    tips: ["Niente rischi: nessuna gita lontana per non perdere il traghetto."],
    gallery: [
      { url: PHOTOS.leGhiaie, caption: "Le Ghiaie" },
      { url: PHOTOS.portoferraioMarina, caption: "Porto di Portoferraio" },
    ],
  },
];

// Default packing list — utente potrà aggiungerne altri
export const DEFAULT_PACKING = [
  { cat: "Mare", items: ["Costumi (x3 a testa)", "Teli mare", "Ombrellone leggero", "Ciabatte da scoglio", "Maschera + snorkel", "Crema solare 50+", "Doposole", "Borraccia", "Cappellino"] },
  { cat: "Abbigliamento", items: ["Vestiti leggeri", "1 felpa per la sera", "Scarpe da trekking leggere (Canata)", "Sandali comodi", "Camicia elegante per cene", "Occhiali da sole"] },
  { cat: "Documenti", items: ["Carta d'identità x2", "Biglietti traghetto (andata + ritorno)", "Prenotazione hotel", "Patente", "Carte di credito"] },
  { cat: "Auto & tech", items: ["Caricabatterie auto", "Powerbank", "Adattatore per cavo", "Aux/Bluetooth per musica", "Contanti spiccioli per parcheggi"] },
  { cat: "Kit spiaggia", items: ["Zaino da spiaggia", "Frigo portatile piccolo", "Bottiglie d'acqua", "Snack / frutta / focaccia", "Salviette umidificate", "Sacchetti per rifiuti"] },
  { cat: "Farmacia", items: ["Cerotti", "Antinfiammatorio", "Repellente zanzare", "Pomata scottature", "Farmaci personali"] },
];
